<template>
    <DropDownButton
        :classes-prop="`header-dropdown`"
        btn-classes-prop="c-header__link"
        :is-header-dropdown="true"
    >
        <template #title>
            <span>Pricing</span>
        </template>
        <template #items>
            <ul>
                <li @click="sendMixpanelEvent('For Admins')">
                    <a
                        href="https://pricing.99math.com/"
                        target="_blank"
                        rel="noopener"
                    >
                        For Admins
                    </a>
                </li>
                <li @click="sendMixpanelEvent('For Teachers')">
                    <a
                        href="https://99math.com/premium/"
                        target="_blank"
                        rel="noopener"
                    >
                        For Teachers
                    </a>
                </li>
            </ul>
        </template>
    </DropDownButton>
</template>
<script>
import DropDownButton from '@/core/ui/_legacy/DropDownButton.vue';
import {
    ANONYMOUSEVENTS,
    AnonymousTrackingService,
} from '@/core/services/TrackingService/AnonymousTrackingService';

export default {
    components: {
        DropDownButton,
    },
    methods: {
        sendMixpanelEvent(option) {
            new AnonymousTrackingService().track(
                ANONYMOUSEVENTS.CLICK_ON_PRICING_OPTION,
                {
                    option,
                    country: localStorage.getItem('country_code3'),
                },
            );
        },
    },
};
</script>
<style lang="scss">
@use '@/scss/components/_components.header-dropdown.scss';
</style>
